import OwnerService from "./service";

export * from "./reqres";

export default OwnerService;
